import { DeviceMeasurementSummary } from "../../../Api/mes.api";

export type LotStatus = "quarantine" | "released" | "rejected" | string;

export function formatHrDate(value?: string | Date | null): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("hr-HR");
}

export function formatHrDateTime(value?: string | Date | null): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("hr-HR", { dateStyle: "short", timeStyle: "short" });
}

export function formatNum(value?: number | string | null, digits = 2): string {
  if (value == null || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  return n.toLocaleString("hr-HR", { maximumFractionDigits: digits });
}

export function lotStatusLabel(status: LotStatus): { label: string; className: string } {
  switch (status) {
    case "quarantine":
      return { label: "Karantena", className: "badge badge-quarantine" };
    case "released":
      return { label: "Pušten", className: "badge stock-good" };
    case "rejected":
      return { label: "Odbijen", className: "badge badge-danger" };
    default:
      return { label: status, className: "badge badge-muted" };
  }
}

export function deviceSummaryBadge(s: DeviceMeasurementSummary | undefined) {
  if (!s || s.count === 0) return { label: "Nema testa", className: "fq-device-badge fq-device-none" };
  if (s.has_valid) return { label: "Valjano", className: "fq-device-badge fq-device-ok" };
  return { label: "Nepregledano", className: "fq-device-badge fq-device-pending" };
}
